module.exports = __webpack_public_path__ + "static/media/235bb582.jpg";